import HomePage from './pages/HomePage';
import ContactUsPage from './pages/ContactUsPage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import ApartmentOnboardingPage from './pages/ApartmentOnboardingPage';
import EventsPage from './pages/EventsPage';
import AboutUsPage from './pages/AboutUsPage';
import Faq from './feature/Faq/Faq';
import EventDetail from './feature/Events/EventDetail';
export const AppRoutes = [
	{
		path: "/",
		Component:HomePage
	},
	{
		path: "/ContactUs",
		Component: ContactUsPage
	},
	{
		path: "/Courses",
		Component:CoursesPage
	},
	{
		path: "/CoursesDetail/:id",
		Component:CourseDetailPage
	},
	{
		path: "/Apartmentonboarding",
		Component: ApartmentOnboardingPage 
	},
	{
		path: "/Events",
		Component:EventsPage
	},
	{
		path: "/About",
		Component:AboutUsPage
	},
	{
		path: "/Faq",
		Component:Faq
	},
	{
		path: "/EventDetail/:id",
		Component:EventDetail
	},
]
